import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterHead = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_8_206)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.715 2.18067C20.8454 2.45033 20.8564 2.85057 20.3594 3.72656C19.8663 4.59566 19.0065 5.70467 17.7881 7.27177L14.5473 11.4399L14.5472 11.44C14.5263 11.467 14.5055 11.4936 14.485 11.5199C14.1174 11.992 13.8295 12.3618 13.677 12.8068L13.6769 12.807M20.715 2.18067L13.6769 12.807M10.4161 20.749L10.002 20.1237C9.38367 20.5331 8.99104 20.7907 8.69765 20.9279C8.62866 20.9602 8.57739 20.9799 8.54053 20.9919C8.52973 20.9535 8.51732 20.8978 8.50571 20.8187C8.45822 20.4955 8.45625 20.0226 8.45625 19.2779V14.3951C8.45625 14.3609 8.45627 14.3271 8.4563 14.2937M10.4161 20.749L8.4563 14.2937M13.6769 12.807C13.5246 13.2518 13.525 13.7213 13.5254 14.3213C13.5254 14.3546 13.5255 14.3884 13.5255 14.4226V15.82C13.5255 16.4145 13.5247 16.8095 13.496 17.1183M13.6769 12.807L13.496 17.1183M20.715 2.18067L20.7149 2.18062C20.5855 1.9132 20.2832 1.65923 19.2936 1.51358C18.3109 1.36893 16.9145 1.36694 14.9374 1.36694H7.06565C5.0886 1.36694 3.69216 1.36893 2.70945 1.51358C1.7199 1.65923 1.41749 1.9132 1.28809 2.18064C1.15761 2.4503 1.14667 2.85055 1.64367 3.72655C2.13676 4.59565 2.99655 5.70466 4.21497 7.27176L3.62287 7.73211L4.21497 7.27176L7.37763 11.3395L7.4344 11.4125C7.45518 11.4392 7.47574 11.4656 7.49604 11.4917C7.86399 11.9641 8.1522 12.3342 8.30475 12.7795L20.715 2.18067ZM10.4161 20.749L10.002 20.1237L11.8918 18.8723L12.3058 19.4977L11.8918 18.8723C12.3852 18.5456 12.7122 18.3282 12.9522 18.1347C13.1799 17.9511 13.2852 17.8228 13.3524 17.6973L10.4161 20.749ZM8.4563 14.2937C8.45676 13.6938 8.45712 13.2243 8.30476 12.7796L8.4563 14.2937ZM13.496 17.1183C13.4686 17.4117 13.4198 17.5714 13.3524 17.6972L13.496 17.1183ZM8.46075 21.0093C8.46101 21.0089 8.46476 21.0085 8.47123 21.0091C8.46373 21.01 8.4605 21.0097 8.46075 21.0093ZM8.56464 21.0589C8.56862 21.0638 8.57029 21.0671 8.57012 21.0675C8.56996 21.0679 8.56797 21.0654 8.56464 21.0589Z",
				stroke: "gray",
				strokeWidth: 1.5
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_8_206",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22,
				height: 22,
				fill: "gray"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilterHead);
export { ForwardRef as ReactComponent };
